import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/toPromise';
import {HttpClientService} from "./http-client.service";
import {AppConfigService} from "./app-config.service";

@Injectable()
export class LoginService {

  private apiUrl = AppConfigService.settings.apiUrl + 'auth/';  // URL to web api

  constructor(private http: HttpClientService) { }

  login(username, password): Promise<any[]> {
    const body = new FormData();
    body.append('username', username);
    body.append('password', password);
    return this.http.post(this.apiUrl + 'login', body)
      .toPromise()
      .then(response => response.json() as any[])
      .catch(this.handleError);
  }

  loginSkyswitch(username, password): Promise<any[]> {
    const body = new FormData();
    body.append('username', username);
    body.append('password', password);
    return this.http.post(this.apiUrl + 'skyswitch/login', body)
      .toPromise()
      .then(response => response.json() as any[])
      .catch(this.handleError);
  }

  private handleError(error: any): Promise<any> {
    console.error('An error occurred', error); // for demo purposes only
    return Promise.reject(error.message || error);
  }

}



// WEBPACK FOOTER //
// ./src/app/login.service.ts